(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('ProfessionalAreaDetailController', ProfessionalAreaDetailController);

    ProfessionalAreaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProfessionalArea', 'CustomUser', 'ProfessionalAreaGroup', 'Order'];

    function ProfessionalAreaDetailController($scope, $rootScope, $stateParams, previousState, entity, ProfessionalArea, CustomUser, ProfessionalAreaGroup, Order) {
        var vm = this;

        vm.professionalArea = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:professionalAreaUpdate', function(event, result) {
            vm.professionalArea = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
